import {createContext, useContext, useState, useEffect} from "react";
const CartContext = createContext();
export function useCart(){
    return useContext(CartContext);
}

export function CartProvider({children}){
    const [items, setItems] = useState(_=>{
            const saved = localStorage.getItem("cart");
            return saved?JSON.parse(saved):[];
    });

    // [] persist through pages
    useEffect(_=>{
        localStorage.setItem("cart", JSON.stringify(items));
    }, [items]);

    // [] helpers
    const addItem = (pdt, qty=1)=>{
        setItems(prev=>{
            const existing = prev.find(i=>i.id === pdt.id);
            
            // [] item in items already, increace qty
            if(existing){
                return prev.map(i=>i.id === pdt.id?{...i, qty: i.qty + qty}:i);
            }

            // [] item not in items yet, append item
            return [...prev, {...pdt, qty}]
        });
    };

    const removeItem = id=>{
        setItems(prev=>prev.filter(i=>i.id !== id));
    };

    const updateItem = (id, qty)=>{
        setItems(prev=>prev.map(i=>i.id === id?{...i, qty:Math.max(qty, 1)}:i));
    };

    const clearCart = _=>setItems([]);

    const totalItems = items.reduce((sum, i)=>sum + i.qty, 0);
    const totalPrice = items.reduce((sum, i)=>sum + i.price, 0);

    return <CartContext.Provider
        value={{
            items,
            addItem,
            removeItem,
            updateItem,
            clearCart,
            totalItems,
            totalPrice
        }}    
    >
        {children}
    </CartContext.Provider>
}